import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';
import { isCardElementEditable } from '../../../../../../../services/cards/components/AccountCard/helpers';
import { MAX_Z_INDEX } from '../../../../helpers';

export const BASE_LOGO_FRAME = {
  x: 0.4,
  y: 0.05,
  width: 0.3,
  height: 0.3,
};

/**
 * Determines whether an element is the Card's Logo.
 * We're using a photo element by default.
 *
 * @param {Object} element The element.
 * @returns {boolean}
 */
export const isElementCardLogo = element => {
  if (!element) {
    return false;
  }

  const { cardElement } = element;
  const isPhoto = cardElement.type === CARD_ELEMENT_TYPE.PHOTO;
  const isMaxZIndex = cardElement.z_index === MAX_Z_INDEX;
  const isEditable = isCardElementEditable(element);

  return isPhoto && isMaxZIndex && !isEditable;
};
